var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "rounded text-white font-bold transition",
      class: [
        `btn-size-${_vm.size} color-${_vm.color} hover-color-${_vm.hoverColor}`,
        { "pointer-events-none": _vm.disabled },
      ],
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }